const getImageHeight = (imageWidth: number, aspectRatioX?: number, aspectRatioY?: number): number => {
    if (aspectRatioX && aspectRatioY) {
        return (imageWidth / aspectRatioX) * aspectRatioY;
    } else {
        return (imageWidth / 4) * 3;
    }
};

export default getImageHeight;
